import React from 'react';
import { cn } from '@/lib/utils';

interface AnimationProps {
  direction?: 'left' | 'right' | 'up' | 'down';
  children: React.ReactNode;
  className?: string;
  delay?: number;
}

// Replace Framer Motion with optimized CSS animations
export function SlideAnimation({ 
  direction = 'right', 
  children, 
  className,
  delay = 0 
}: AnimationProps) {
  const animationClass = {
    right: 'animate-slide-in-right',
    left: 'animate-in slide-in-from-left-5 duration-300',
    up: 'animate-in slide-in-from-bottom-5 duration-300',
    down: 'animate-in slide-in-from-top-5 duration-300'
  }[direction];

  return (
    <div 
      className={cn(
        animationClass,
        "ease-out",
        className
      )}
      style={{ 
        animationDelay: `${delay}ms`,
        animationFillMode: 'both'
      }}
    >
      {children}
    </div>
  );
}

export function FadeAnimation({ children, className, delay = 0 }: Omit<AnimationProps, 'direction'>) {
  return (
    <div 
      className={cn(
        "animate-fade-in ease-out",
        className
      )}
      style={{ 
        animationDelay: `${delay}ms`,
        animationFillMode: 'both'
      }}
    >
      {children}
    </div>
  );
}

export function ScaleAnimation({ children, className, delay = 0 }: Omit<AnimationProps, 'direction'>) {
  return (
    <div 
      className={cn(
        "animate-scale-in ease-out",
        className
      )}
      style={{ 
        animationDelay: `${delay}ms`,
        animationFillMode: 'both'
      }}
    >
      {children}
    </div>
  );
}

// Combined animation for complex transitions
export function EnterAnimation({ 
  children, 
  className, 
  delay = 0,
  variant = 'fade-scale'
}: Omit<AnimationProps, 'direction'> & { variant?: 'fade-scale' | 'slide-fade' }) {
  const animationClass = variant === 'fade-scale' 
    ? 'animate-in fade-in-0 zoom-in-95 duration-300'
    : 'animate-in fade-in-0 slide-in-from-bottom-4 duration-300';

  return (
    <div 
      className={cn(
        animationClass,
        "ease-out",
        className
      )}
      style={{ 
        animationDelay: `${delay}ms`,
        animationFillMode: 'both'
      }}
    >
      {children}
    </div>
  );
}